import { memo } from "react";
import upcomingLogo from "@/assets/corporate-actions/upcoming.svg";
import todayLogo from "@/assets/corporate-actions/today.svg";
import qualifyLogo from "@/assets/corporate-actions/qualifying.svg";
import lastDay from "@/assets/corporate-actions/lastDay.svg";
import Image from "next/image";
import { Mixpanel } from "../Mixpanel";

function EventCard({ data, onClick, symbol }) {
    return (
        <div className={`relative  w-full `}>
            {data.tile?.tag && (
                <Image
                    src={
                        data.tile.tag === "Today"
                            ? todayLogo
                            : data.tile.tag === "Upcoming"
                            ? upcomingLogo
                            : data.tile.tag === "Last day to Qualify"
                            ? lastDay
                            : qualifyLogo
                    }
                    alt={data.tile.tag}
                    className="absolute -top-1 right-0 w-[112px] "
                />
            )}

            <div className="w-full font-Inter border border-[#61B2F3] rounded-xl  overflow-hidden">
                <div className="text-xs text-black font-bold py-3 px-4 bg-[#ECF6FE]">
                    {data.tile?.header}{" "}
                    {data.tile?.subHeader && <span className="font-normal ">({data.tile?.subHeader})</span>}
                </div>
                <div
                    onClick={() => {
                        if (data?.tile?.description) {
                            onClick(data);
                            Mixpanel.track("page_viewed", {
                                page: "event_more_info_bf",
                                symbol: symbol,
                                tab: "news_events",
                                tile_header: data.tile?.header
                            });
                        }
                    }}
                    className="py-3 px-4"
                >
                    <div className="w-full flex flex-row justify-between ">
                        <div className=" min-w-[80px] text-xs text-black font-medium flex flex-col gap-1 leading-5 ">
                            <span className="text-[#606060]">{data?.tile?.r2Left?.label}</span>
                            <b>{data?.tile?.r2Left?.value}</b>
                        </div>
                        <div className=" min-w-[80px] text-xs text-black font-medium flex flex-col gap-1 leading-5">
                            <span className="text-[#606060]">{data?.tile?.r2Middle?.label}</span>
                            <b>{data?.tile?.r2Middle?.value}</b>
                        </div>
                        <div className=" min-w-[80px] text-xs text-black font-medium flex flex-col gap-1 leading-5">
                            <span className="text-[#606060]">{data?.tile?.r2Right?.label}</span>
                            <b>{data?.tile?.r2Right?.value}</b>
                        </div>
                    </div>
                    {data?.tile?.description && (
                        <div className="text-xs w-full text-[#747474] font-normal mt-3 pt-3 border-t">
                            <div className="flex items-center">
                                <div className=" leading-5 ">
                                    {data?.tile?.description?.length > 30
                                        ? `${data?.tile?.description.slice(0, 30)}...`
                                        : data?.tile?.description ?? "-"}
                                </div>
                                {data?.tile?.description?.length > 30 && (
                                    <button className="text-primary/80 underline cursor-pointer inline whitespace-nowrap ">
                                        Read more
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default memo(EventCard);
